import { Component, Input } from '@angular/core';
import type { PalantirSize } from '../../shared/interfaces/sizes.interface';
import { PalantirIconComponent } from '../icon/icon.component';
import type { PalantirIcon } from '../icon/icon.type';
import type {
  PalantirButtonLayout,
  PalantirButtonShape,
  PalantirButtonTheme,
  PalantirButtonVariant,
} from './button.type';

@Component({
  selector: 'palantir-button',
  standalone: true,
  imports: [PalantirIconComponent],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class PalantirButtonComponent {
  @Input() public icon?: PalantirIcon;

  @Input() public disabled?: boolean;

  @Input() public theme?: PalantirButtonTheme;

  @Input() public size?: PalantirSize;

  @Input() public layout?: PalantirButtonLayout;

  @Input() public shape?: PalantirButtonShape;

  @Input() public variant?: PalantirButtonVariant;
}
